import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Main from './main';
import Home from './home';
import HomeDE from './homeDE';

function App() {
  const [message, setMessage] = useState('');


  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />  
          <Route path="/de" element={<HomeDE />} />   
        </Routes>
      </div>
    </Router>
  );
}

export default App;